export default __webpack_public_path__ + "static/media/September2010.92a4bb94.png";